import { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { Box, HStack, VStack, useMediaQuery } from "native-base";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { COLORS } from "../../utils/colors";
import MobileRequestEventBanner from "./banner/mobileRequestEventBanner";
import WebRequestEventBanner from "./banner/webRequestEventBanner";
import RequestDetail from "./requestDetail";
import PhotosListing from "./photosListing";
import ReviewDetails from "./reviewsListing";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { AgencyApproval } from "./agencyApproval";
import { eventDetailsAPI, getAllReviewsAPI } from "../../api/apis/event";
import { Toaster } from "../../components/toaster";
import {
  activeEventTab,
  setSelectedEvent,
} from "../../store/reducers/eventSlice";
import { hasPermission } from "../../utils/permission";
import {
  getApprovedImages,
  getSchemaAPI,
  getUserImagesCards,
  getUserImagesUnderReviewCards,
  getWorkflowAPI,
  putWorkflowAPI,
  updateWorkflowAPI,
} from "../../api/apis/workflow";
import { schemaExtractor } from "../../utils/schemaExtractor";
import EventBreakDownDetails from "./eventBreakdown";
import config from "../../utils/config";

const RequestEventDetailPage = () => {
  const toaster = Toaster();
  const dispatch = useDispatch();
  const eventBytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("event"),
    config.eventKey
  );
  const eventString = eventBytes.toString(CryptoJS.enc.Utf8);
  const selectedEvent = JSON.parse(eventString);
  const eventsDetail = useSelector((state) => {
    return state.event.selectedEvent;
  });
  const [workflow, setWorkflow] = useState({});
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [selected, setSelected] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [imageFormData, setImageFormData] = useState({});
  const [reviewFormData, setReviewFormData] = useState({});
  const [images, setImages] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [userImageCard, setUserImageCard] = useState([]);
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [isLoading, setIsLoading] = useState(true);
  const [tabActive, setTabActive] = useState("Day 1");

  useEffect(() => {
    scrollToTop();
    if (selectedEvent === null || Object.keys(selectedEvent).length === 0) {
      setShouldRedirect(true);
    }
    setUserImageCard([]);
    try {
      selectedEvent.agency.map((item) => {
        if (item.status === "active") {
          setSelectedAgency(true);
        }
        if (item.emailId === userInfo.email) {
          if (item.status === "active") {
            setSelected(true);
          } else if (item.status === "inactive") {
            setSelected(false);
          }
        }
      });
      dispatch(activeEventTab(selectedEvent.type));
      getEventDetails(selectedEvent._id);
      AddWorkflow(selectedEvent._id);
      getSchema(selectedEvent);
    } catch (e) {
    } finally {
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getEventDetails = async (event_id = selectedEvent._id) => {
    setIsLoading(true);
    let res = await eventDetailsAPI(event_id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      dispatch(setSelectedEvent(res.data.data.data));
    }
    setIsLoading(false);
  };

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        let allStatus = ["NEW", "pending"];
        item &&
          item.steps &&
          item.steps.map((status) => {
            allStatus.push(status.name);
          });
        if (item.name === "EventWorkflow") {
          workflows["event"] = item;
        }
        if (item.name === "ImageWorkflow") {
          workflows["image"] = item;
        }
        if (item.name === "ReviewWorkflow") {
          workflows["review"] = item;
        }
      });
      setWorkflow(workflows);
      if (workflows["image"]["_id"] && hasPermission("IMAGES_REVIEWS")) {
        getImages(selectedEvent._id);
      }
      if (workflows["review"]["_id"] && hasPermission("IMAGES_REVIEWS")) {
        getReviews(workflows["review"]["_id"], selectedEvent._id);
      }
      // hasPermission("USER_IMAGE_CARD") && getUserImagesCard(selectedEvent._id);
      // hasPermission("USER_IMAGE_UNDER_REVIEW_CARD") &&
      //   getUserImagesUnderReviewCard(selectedEvent._id);
    }
  };

  const getImages = async (event_id, page_no = 1, per_page = 6) => {
    setIsLoading(true);
    let res = await getApprovedImages(event_id, page_no, per_page);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      if (res?.data?.data?.data.length > 0) setImages(res?.data?.data?.data);
      else setImages([]);
    }
    setIsLoading(false);
  };

  const getUserImagesCard = async (event_id) => {
    let res = await getUserImagesCards(event_id, selectedEvent.type);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      setUserImageCard(res?.data?.data?.data);
    }
  };

  const getUserImagesUnderReviewCard = async (event_id) => {
    let res = await getUserImagesUnderReviewCards(event_id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let data = res?.data?.data?.data;
      if (data[0]) {
        data[0].user_image_count = data[0]?.pending_images.length;
        data[0].user_name = userInfo.first_name;
      }
      setUserImageCard(data);
    }
  };

  const getReviews = async (
    workflow_id = workflow["review"]["_id"],
    event_id = selectedEvent._id
  ) => {
    let res = await getAllReviewsAPI(workflow_id, event_id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      setReviews(res?.data?.data?.data);
    }
  };

  const getSchema = async () => {
    let imageDocumentSchema = "";
    let reviewDocumentSchema = "";
    let res = await getSchemaAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      res &&
        res.data.data.data &&
        res.data.data.data?.map((item) => {
          if (item.title === "ADD_IMAGES") {
            imageDocumentSchema = item;
          }
          if (item.title === "ADD_REVIEWS") {
            reviewDocumentSchema = item;
          }
        });
    }

    if (imageDocumentSchema) {
      let extracted = schemaExtractor(imageDocumentSchema?.properties);
      setImageFormData(extracted);
    }
    if (reviewDocumentSchema) {
      let extracted = schemaExtractor(reviewDocumentSchema?.properties);
      setReviewFormData(extracted);
    }
  };

  if (shouldRedirect) {
    return <Redirect to="/home" />;
  }

  const updateWorkflow = async (data, type, workflow_name) => {
    let id = "";
    if (workflow_name === "event") {
      id = workflow["event"]["_id"];
    }
    if (workflow_name === "image") {
      id = workflow["image"]["_id"];
    }
    if (workflow_name === "review") {
      id = workflow["review"]["_id"];
    }

    if (id !== "") {
      let res = await updateWorkflowAPI(data, id, type);
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        if (workflow_name === "event") {
          toaster("Updated Successfully", "success", "success");
        }
        if (workflow_name === "image") {
          toaster("Image added Successfully", "success", "success");
        }
        if (workflow_name === "review") {
          toaster("Review added Successfully", "success", "success");
        }

        getReviews();
      }
    }
  };

  const approveAgencyWorkflow = async (data, step, id, action_name) => {
    let res = await putWorkflowAPI(
      data,
      workflow["event"]["_id"],
      step,
      id,
      action_name
    );
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      toaster("The agency has been approved ", "success", "success");
    }
  };

  const approveReviewWorkflow = async (data, step, id, action_name) => {
    let res = await putWorkflowAPI(
      data,
      workflow["review"]["_id"],
      step,
      id,
      action_name
    );
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      toaster("Updated Successfully", "success", "success");
    }
  };

  return (
    <Box bg={COLORS.THEME_BACKGROUND} pb={8} w={"100%"} minHeight={"100vh"}>
      {MobileWindow ? (
        <MobileRequestEventBanner
          bannerPath={eventsDetail?.["banner"]}
          isLoading={isLoading}
        />
      ) : (
        <WebRequestEventBanner
          bannerPath={eventsDetail?.["banner"]}
          isLoading={isLoading}
        />
      )}
      <VStack
        px={MobileWindow ? "15px" : "5rem"}
        py="30px"
        space={!MobileWindow ? 12 : 6}
      >
        <RequestDetail
          workflow={workflow}
          getEventDetails={getEventDetails}
          scrollToTop={scrollToTop}
        />
        <HStack
          pl={hasPermission("VENDOR") && 1}
          space={4}
          w={"100%"}
          direction={MobileWindow ? "column" : "row"}
        >
          {MobileWindow &&
            !selectedAgency &&
            hasPermission("AGENCY_APPROVAL") && (
              <AgencyApproval
                getEventDetails={getEventDetails}
                approveAgencyWorkflow={approveAgencyWorkflow}
                eventsDetail={eventsDetail}
              />
            )}
          <Box w={hasPermission("VENDOR") ? "100%" : !MobileWindow && "70%"}>
            {hasPermission("IMAGES_REVIEWS") && (
              <PhotosListing
                userImageCard={userImageCard}
                updateWorkflow={updateWorkflow}
                eventsDetail={eventsDetail}
                getImages={getImages}
                images={images}
                getUserImagesUnderReviewCard={getUserImagesUnderReviewCard}
                isLoading={isLoading}
                scrollToTop={scrollToTop}
              />
            )}
            {((!MobileWindow && hasPermission("BREAKDOWN")) ||
                MobileWindow) && (
                <EventBreakDownDetails
                  selected={selected}
                  setTabActive={setTabActive}
                  eventsDetail={eventsDetail}
                  getEventDetails={getEventDetails}
                />
              )}
            {hasPermission("VENDOR") && selected && (
              <EventBreakDownDetails
                selected={selected}
                setTabActive={setTabActive}
                eventsDetail={eventsDetail}
                getEventDetails={getEventDetails}
              />
            )}
          </Box>

          <VStack
            w={!hasPermission("VENDOR") && !MobileWindow && "29%"}
            space={5}
          >
            {!MobileWindow &&
              !selectedAgency &&
              hasPermission("AGENCY_APPROVAL") && (
                <AgencyApproval
                  getEventDetails={getEventDetails}
                  approveAgencyWorkflow={approveAgencyWorkflow}
                  eventsDetail={eventsDetail}
                />
              )}
            {hasPermission("IMAGES_REVIEWS") && (
              <ReviewDetails
                getReviews={getReviews}
                getEventDetails={getEventDetails}
                reviews={reviews}
                updateWorkflow={updateWorkflow}
                eventsDetail={eventsDetail}
                reviewFormData={reviewFormData}
                approveReviewWorkflow={approveReviewWorkflow}
                scrollToTop={scrollToTop}
                isLoading={isLoading}
              />
            )}
            {selectedAgency && (hasPermission("AGENCY_APPROVAL") ||
            hasPermission("AGENCY")) && (
              <AgencyApproval
                getEventDetails={getEventDetails}
                approveAgencyWorkflow={approveAgencyWorkflow}
                eventsDetail={eventsDetail}
              />
            )}

            {/* {!hasPermission("VENDOR") &&
              ((!MobileWindow && hasPermission("BREAKDOWN")) || MobileWindow) &&
              eventsDetail &&
              eventsDetail.event_break_down &&
              eventsDetail.event_break_down.length > 0 &&
              eventsDetail?.event_break_down[
                parseInt(tabActive.split(" ")[1]) - 1
              ][tabActive]?.sightseeing && (
                <SightSeeingCards
                  detail={
                    eventsDetail?.event_break_down[
                      parseInt(tabActive.split(" ")[1]) - 1
                    ][tabActive]?.sightseeing
                  }
                />
              )} */}
          </VStack>
        </HStack>
      </VStack>
    </Box>
  );
};

export default RequestEventDetailPage;
